import React, { Component } from 'react';
import { memo } from 'react';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWindowClose,faTimesCircle, faCheckCircle  } from '@fortawesome/free-solid-svg-icons';
import "../../css/admin/ModalAdminEliminar.css";
export class ModalAdminEliminar extends Component {
    render() {
        return (
            <div className="modalEliminar-background">
          <div className="modalEliminar-container">
            <div className="modalEliminar-header1">
              <button className="modalEliminar-close" onClick={this.props.cerrarModal} >
                <FontAwesomeIcon icon={faWindowClose}></FontAwesomeIcon>
              </button>
            </div>
            {this.props.children}
            <div className="modalEliminar-container-botonGuardar">
                <button className="modalEliminar-botones" onClick={this.props.submit}>
                    <FontAwesomeIcon icon={faCheckCircle} className='modalEliminar-icono-bnt'></FontAwesomeIcon>
                        {this.props.txtBtnSubmit}
                        {!this.props.activebuttonAcept ?
                            <span className="spinner-border spinner-border-sm text-primary ms-1" role="status" aria-hidden="true"></span>
                        : null}
                </button>
                
                <button className="modalEliminar-botones" onClick={this.props.cerrarModal}>
                <FontAwesomeIcon icon={faTimesCircle} className='modalEliminar-icono-bnt'></FontAwesomeIcon>
                {this.props.txtBtnCancel}
                </button>
            </div>
          </div>
          
          
        </div>
        )
    }
}

export default memo(ModalAdminEliminar);
